 /** @jsxImportSource @emotion/react */
 import { css} from '@emotion/react';
import React,{memo, useEffect, useRef, useState} from 'react'
import { PlusOutlined,MinusCircleOutlined,ArrowUpOutlined,ArrowDownOutlined } from '@ant-design/icons';
import { Button, Checkbox, DatePicker, Form, Input, Radio, Spin} from 'antd'
import { Select, Space } from 'antd';
import Alert from '../alert'
import axios from '../apiClient';
import moment from 'moment';
import Loader from '../loader';
import { Backdrop, Box, ButtonBase, Fade, Modal } from '@mui/material';
import jwtDecode from 'jwt-decode';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
// import { VariableSizeList as List } from 'react-window';
import { FixedSizeList as List } from 'react-window';


export default function AddOdds() {
    const [leagues, setLeagues] = useState([]);
    const [matches,setMatches] = useState([])
    const [originalLeagues,setOriginalLeagues] = useState([])
    const [loading,setLoading] = useState(true)
    const [saveOddsLoading,setSaveOddsLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState({});
    const [openAlert, setOpenAlert] = useState(false);
    const [createCardOptions,setCreateCardOptions] = useState(["FT"]);
    const [form] = Form.useForm();
    const [matchLang,setMatchLang] = useState("eng")
    const [createCardMode,setCreateCardMode] = useState(false);
    const [openAddMatchModal,setOpenAddMatchModal] = useState(false);


    //  {data: [
    //   {
    //     leagueId: "30",
    //     matches: [
    //        {matchId: "23423",periods: 'full_time',betType: 'all',popular: false,maxLimit: 0,...},
    //        {matchId: "23423",periods: 'full_time',betType: 'all',popular: false,maxLimit: 0,...}
    //       ]
    //   },
    //   {
    //     leagueId: "40",
    //     matches: [
    //        {matchId: "23423",periods: 'full_time',betType: 'all',popular: false,maxLimit: 0,...},
    //        {matchId: "23423",periods: 'full_time',betType: 'all',popular: false,maxLimit: 0,...}
    //       ]
    //   }
    //  ]}



    //     matches: [
    //        {matchId: "23423",periods: 'full_time',betType: 'all',popular: false,maxLimit: 0,...},
    //        {matchId: "23423",periods: 'full_time',betType: 'all',popular: false,maxLimit: 0,...}
    //     ]

    const handleAddMatchModelClose = () => setOpenAddMatchModal(false);
    const handleAddMatchModelOpen = () => setOpenAddMatchModal(true);
    
    useEffect(()=>{
      const oddLang = JSON.parse(localStorage.getItem("oddLang"));
      if(oddLang && (oddLang == "my" || oddLang == "eng")) setMatchLang(oddLang)
      fetchData();
      form.setFieldsValue({data: [{leagueId: null,matches: []}]})
      setTimeout(() => {
        form.getFieldInstance(['data',0,'leagueId'])?.focus()
      }, 100);
    },[])

    useEffect(()=>{
      fetchData();
    },[matchLang])
   
    function handleLeagueSearch(query){
       const arr = originalLeagues.filter(v => v.label.toLowerCase().includes(query.toLowerCase()));
       setLeagues(arr)
    }

    async function fetchData() {
        const startOfDay = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
        const endOfTmr = moment().add(1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');

        const data = await axios.get(`/info/getLeagueByStatusAndDate?startDate=${startOfDay}&endDate=${endOfTmr}&matchStatus=NS`)

  
        if (data.code != 200) {
            setErrorMsg({ code: data.code, msg: data.message })
            setOpenAlert(true)
            setLoading(false)
            return
        }
        const arr = data.data.map(v=> { return ({value: v.id,label: v.value_en,label_mm: v.value_mm,label_en: v.value_en})})
        setLeagues(arr)
        setOriginalLeagues(arr)
        setLoading(false)
    }

    async function handleLeagueChange(value,leagueIndex){
        setLeagues(originalLeagues)
        const startOfDay = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
        const endOfTmr = moment().add(1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
        // I have removed pagination logic
        const data = await axios.get(`/info/getMatchByLeagueId?leagueId=${value}&&startDate=${startOfDay}&endDate=${endOfTmr}&matchStatus=NS`)

        if (data.code != 200) {
            setErrorMsg({ code: data.code, msg: data.message })
            setOpenAlert(true)
            setMatches([])
            // form.setFieldsValue({match: null});
            return
        }
        // form.setFieldsValue({match: null});
        // form.setFieldsValue({'hdp/ou': "Body"});
        const obj = form.getFieldsValue()
        obj.data[leagueIndex].matches = [{}]
        form.setFieldsValue(obj)
        const matchName = matchLang == 'my' ? 'name_mm' : 'name_en';

        const arr = data.data[0].match.map(v=> { return (
          {
            value: v.matchId,
            label: `${v.homeTeam.name_en}-${v.awayTeam.name_en}`,
            label_mm: `${v.homeTeam.name_mm}-${v.awayTeam.name_mm}`,
            label_en: `${v.homeTeam.name_en}-${v.awayTeam.name_en}`,
            matchTime: moment(v.matchDate).format('DD-MM-YYYY h:mm A'),
            matchStatus: v.status
          }
        )})
        matches[leagueIndex] = arr
        setMatches(matches)
        setTimeout(() => {
          form.getFieldInstance(['data',leagueIndex,'matches', 0, 'matchId'])?.focus()
        }, 100);
    }

    function handleMatchChange (v){
    }

    const validataBeforeSave = async(values) =>{
        if(values.data.length == 0 ) {
          setErrorMsg({ info: true, msg: "Please input first" })
          setOpenAlert(true)
          return 500
        }
        if(createCardMode){
          try {
            await form.validateFields();
            return 200
          } catch (error) {
            setErrorMsg({ info: true, msg: "Invalid Format" })
            setOpenAlert(true)
            return 500
          }
         
        }
        let msg = ""
        loop1:
        for (let z = 0; z < values.data.length; z++) {
          const {matches,leagueId} = values.data[z];
        
          if(!leagueId){
            msg = "Select league"
          }else if(matches.length == 0){
            msg = "Select at least one match"
          }else{
            loop2:
            for (let index = 0; index < matches.length; index++) {
              const v = matches[index];
              if(!v.matchId) {msg = `Select Match in ${index+1} card`; z=index=1000;break;}
              if(!v.bodyHandicapTeam) {msg = `Select body handicap team in No ${index+1} match card of No ${z+1} league card`; z=index=1000;break;}
              // if(!v.bodyHandicapGoal) {msg = `Input body handicap goal in ${index+1} card`  ; break ;}
              if(!v.bodyOdd)  {msg = `Input body odd in No ${index+1} match card of No ${z+1} league card` ; z=index=1000;break;}
              // if(!v.ouHandicapGoal) {msg = `Input over/under handicap goal in ${index+1} card`; break;}
              if(!v.ouOdd)  {msg = `Input over/under odd in No ${index+1} match card of No ${z+1} league card`; z=index=1000;break;}
            }
          }
        }
        if(msg){
          setErrorMsg({ info: true, msg: msg })
          setOpenAlert(true)
          return 500
        }else{
          return 200
        }

    }

    const changeFormat = (values) => {
      if(!createCardMode) return values
      const copy = JSON.parse(JSON.stringify(values));
      const leagues = copy.data;
      const returnData = {data: []};
      for (let z = 0; z < leagues.length; z++) { // loop the leagues
        const matches = [];
        for (let i = 0; i < leagues[z].matches.length; i++) { // loop the matches
          const match = leagues[z].matches[i];
          const hdp = match.hdp;
          const ou = match["o/u"];
          const homeTeamHasHandicap = match.homeTeamHasHandicap;
          if(!hdp || !ou || homeTeamHasHandicap == null) { // delete that index
            continue
          }else{
            const [hdpLeft,hdpSign, hdpRight] = hdp.match(/(\d+|[-+])/g)
            const [ouLeft,ouSign, ouRight] = ou.match(/(\d+|[-+])/g)
            match.bodyHandicapGoal = hdpLeft;
            match.bodyHandicapTeam = homeTeamHasHandicap ? "home_team" : "away_team";
            match.bodyOdd = hdpRight;
            match.bodyOddSign = hdpSign;
            match.ouHandicapGoal = ouLeft;
            match.ouOdd = ouRight;
            match.ouOddSign = ouSign;
            delete match.awayTeam;
            delete match.homeTeam;
            delete match.hdp;
            delete match['o/u'];
            matches.push(match);
          }
        }
        if(matches.length == 0) continue;
        returnData.data.push({leagueId:  leagues[z].leagueId,matches})
      }
      return returnData;
    }

    const handleSave = async (values) =>{
      return;
      const formatedData = changeFormat(values);
     
      const code = await validataBeforeSave(formatedData);
      if(code != 200) return;
      setSaveOddsLoading(true)
     
      const token = localStorage.getItem("token");
      const {id: ownerId} = jwtDecode(token);
      let matchesArr =[];
      formatedData.data.forEach(({matches,leagueId}) => { 
        matches.forEach(match => matchesArr.push(match) )
      });
      const odds = matchesArr.map((v)=>{
          const {matchId,bodyHandicapGoal,bodyHandicapTeam,bodyOdd,bodyOddSign,ouHandicapGoal,ouOdd,ouOddSign,periods,betType,maxLimit} = v
          return ({
          matchId: matchId,
          popular: v?.popular ? 1 : 0,
          hdp: {
              raw: [
                  bodyHandicapGoal,
                  bodyOddSign+bodyOdd
              ],
              converted: `${bodyHandicapGoal}${bodyOddSign+bodyOdd}`,
              home_team_has_hadicap: bodyHandicapTeam == 'home_team' ? true : false,  
          },
          ou: {
              raw: [
                  ouHandicapGoal,
                  ouOddSign+ouOdd
              ],
              converted: `${ouHandicapGoal}${ouOddSign+ouOdd}`,
              home_team_has_hadicap: bodyHandicapTeam == 'home_team' ? true : false,  
          },
          periods: periods,
          betType: betType,
          maxLimitBetAmount: 0,
          createdBy: ownerId
      })})

      const params = {odds}

      const data = await axios.post(`/bet/setOddByMatchId`, params)

      setErrorMsg({ code: data.code, msg: data.message })
      setOpenAlert(true)
      setSaveOddsLoading(false)
    }

    const validataBeforeSave2 = async(values) =>{
      if(values.matches.length == 0 ) {
        setErrorMsg({ info: true, msg: "Please input first" })
        setOpenAlert(true)
        return 500
      }

      try {
        await form.validateFields();
        return 200
      } catch (error) {
        setErrorMsg({ info: true, msg: "Invalid Format" })
        setOpenAlert(true)
        return 500
      }

    }

    const changeFormat2 = (values) => {
    const copyMatches = JSON.parse(JSON.stringify(values)).matches;
    let returnData = {};

    const matches = [];
    for (let i = 0; i < copyMatches.length; i++) { // loop the matches
      const match = copyMatches[i];
      const hdp = match.hdp;
      const ou = match["o/u"];
      const homeTeamHasHandicap = match.homeTeamHasHandicap;
      if(!hdp || !ou || homeTeamHasHandicap == null) { // delete that index
        continue
      }else{
        const [hdpLeft,hdpSign, hdpRight] = hdp.match(/(\d+|[-+])/g)
        const [ouLeft,ouSign, ouRight] = ou.match(/(\d+|[-+])/g)
        match.bodyHandicapGoal = hdpLeft;
        match.bodyHandicapTeam = homeTeamHasHandicap ? "home_team" : "away_team";
        match.bodyOdd = hdpRight;
        match.bodyOddSign = hdpSign;
        match.ouHandicapGoal = ouLeft;
        match.ouOdd = ouRight;
        match.ouOddSign = ouSign;
        delete match.awayTeam;
        delete match.homeTeam;
        delete match.hdp;
        delete match['o/u'];
        matches.push(match);
      }
    }
    returnData = {matches: matches}
    
    return returnData;
    }

    const handleSave2 = async (values) =>{
      // console.log("values before format:", values);

      const formatedData = changeFormat2(values);
    
      const code = await validataBeforeSave2(formatedData);
      if(code != 200) return;
      setSaveOddsLoading(true);
    
      const token = localStorage.getItem("token");
      const {id: ownerId} = jwtDecode(token);
      let matchesArr = formatedData.matches;
      
    
      const odds = matchesArr.map((v)=>{
          const {matchId,bodyHandicapGoal,bodyHandicapTeam,bodyOdd,bodyOddSign,ouHandicapGoal,ouOdd,ouOddSign,periods,betType,maxLimit, secondMatchDate = null} = v

          let formattedSecondMatchDate = moment(secondMatchDate, 'DD-MM-YYYY hh:mm:ss A').format('YYYY-MM-DD HH:mm:ss');

          return ({
          matchId: matchId,
          popular: v?.popular ? 1 : 0,
          hdp: {
              raw: [
                  bodyHandicapGoal,
                  bodyOddSign+bodyOdd
              ],
              converted: `${bodyHandicapGoal}${bodyOddSign+bodyOdd}`,
              home_team_has_hadicap: bodyHandicapTeam == 'home_team' ? true : false,  
          },
          ou: {
              raw: [
                  ouHandicapGoal,
                  ouOddSign+ouOdd
              ],
              converted: `${ouHandicapGoal}${ouOddSign+ouOdd}`,
              home_team_has_hadicap: bodyHandicapTeam == 'home_team' ? true : false,  
          },
          periods: periods,
          betType: betType,
          maxLimitBetAmount: 0,
          createdBy: ownerId,
          secondMatchDate :formattedSecondMatchDate
      })})

      const params = {odds}

      const data = await axios.post(`/bet/setOddByMatchId`, params)

      setErrorMsg({ code: data.code, msg: data.message })
      setOpenAlert(true)
      setSaveOddsLoading(false)
    }

    const onFinish = async (values) => handleSave(values);

    const onFinish2 = async (values) => handleSave2(values);

    const handleDefault = async() => {
      setLoading(true);
      setCreateCardMode(false);
      form.resetFields();
      setMatches([])
      form.setFieldsValue({data: [{leagueId: null,matches: []}]})
      await new Promise((resolve)=> setTimeout(resolve,500))
      setLoading(false)
    };

    
    const handleCreateCards = async () => {    
      setCreateCardMode(true)
      setLoading(true)
      const startOfDay = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
      const endOfTmr = moment().add(1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
      // const res = await axios.get(`/api/info/getMatchByLeagueId?leagueId=&&startDate=${startOfDay}&endDate=${endOfTmr}&matchStatus=NS`)
      let url = "/bet/getMatchForoddCreate";
      if(createCardOptions.includes("2HT")) url += `?periods=2HT` 
      const res = await axios.get(url);

      
      if (res.code != 200) {
        let msg;
        if(res.code == 404) {
          msg= "There is no match For Fav leagues"
        }else{
          msg = res.message
        }
        setLoading(false)
        form.setFieldsValue({})
        setErrorMsg({ code: res.code, msg: msg})
        setOpenAlert(true)
        return
      }
      let arr =[];
      let matchArr = [];
      let obj={matches: []};
     
      const matches = res.data;

      matchArr = matches.map(v=> { return (
        {
          value: v.matchId,
          label: `${v.homeTeam.name_en}-${v.awayTeam.name_en}`,
          label_mm: `${v.homeTeam.name_mm} vs ${v.awayTeam.name_mm}`,
          label_en: `${v.homeTeam.name_en} vs ${v.awayTeam.name_en}`,
          matchTime: moment(v.matchDate).format('DD-MM-YYYY h:mm A'),
          matchStatus: v.status
        }
      )})

      matches.forEach(m=> {
        let hdpFull;let ouFull; let hdpFirst; let ouFirst; let hdpSecond;let ouSecond;
        let homeFTHdp;let home1HHdp;let home2HHdp;
        let matchStatus = m.status;
        let typeFT = 'all';let type1H = 'all';let type2H = 'all';
        let maxLimitFT = 0;let maxLimit1H = 0;let maxLimit2H = 0;
        let popular = false;
        popular = m.popular == 1 ? true : false;
        
        let OneHOddExist = m.odd?.some(o => o.periods == "first_time");

        if(m.odd){
          m.odd.forEach(o=> {
            if(o.periods == "full_time") {
              hdpFull = o.hdp.converted;
              ouFull = o.ou.converted;
              homeFTHdp = o.hdp.home_team_has_hadicap;
              typeFT = o.type;
              maxLimitFT = o.max_limit_bet_amount;
            }else if(o.periods == "first_time"){
              hdpFirst = o.hdp.converted;
              ouFirst = o.ou.converted;
              home1HHdp = o.hdp.home_team_has_hadicap;
              type1H = o.type;
              maxLimit1H = o.max_limit_bet_amount;
            }else{
              hdpSecond = o.hdp.converted;
              ouSecond = o.ou.converted;
              home2HHdp = o.hdp.home_team_has_hadicap;
              type2H = o.type;
              maxLimit2H = o.max_limit_bet_amount;
            }
          })
        }

        if(createCardOptions.includes("FT"))  obj.matches.push({matchId: m.matchId,periods: "full_time",hdp: hdpFull,['o/u']: ouFull,homeTeamHasHandicap: homeFTHdp,popular: popular,betType: typeFT,maxLimit: maxLimitFT})
        if(createCardOptions.includes("1HT")) obj.matches.push({matchId: m.matchId,periods: "first_time",hdp: hdpFirst,['o/u']: ouFirst,homeTeamHasHandicap: home1HHdp,popular: popular,betType: type1H,maxLimit: maxLimit1H})
        if(createCardOptions.includes("2HT") && (matchStatus == "NS" || matchStatus == "1H" || matchStatus == "HT" )  && OneHOddExist) obj.matches.push({matchId: m.matchId,periods: "second_time",hdp: hdpSecond,['o/u']: ouSecond,homeTeamHasHandicap: home2HHdp,popular: popular,betType: type2H,maxLimit: maxLimit2H})
        
        
      })
      arr.push(obj)
      

      setMatches(matchArr)
      setTimeout(() => {
        document.getElementById(`secondMatchDate-${0}`)?.focus();
        // form.getFieldInstance(['matches',0,'hdp'])?.focus()
      }, 100);
    
      form.resetFields()
      form.setFieldsValue(obj)
      setLoading(false)
      setTimeout(() => {
        
      }, 1000);
    }

    const handleCreateCardOptionChange = (options) => {
      // console.log("options",options);
      if((options.includes("1HT") && options.includes("2HT")) || (options.includes("FT") && options.includes("2HT")) ) return;
      // console.log("pass")
      setCreateCardOptions(options);
    }

    const handleChangeLang = async (lang) => {
      setLoading(true);
      await new Promise(resolve => setTimeout(resolve,100))
      setMatchLang(lang);
      localStorage.setItem('oddLang',JSON.stringify(lang));
      setLoading(false)
    }

    const handleSetMatches = (matches) => setMatches(matches)
    
    const handleOpenAlert =()=> setOpenAlert(true)

    const handleCloseAlert =()=> setOpenAlert(false)

    const handleSetError =(error)=> setErrorMsg(error)

  return (
    <div>
        <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert} />
        
        <Spin spinning={loading}>
        {/* {loading && <Loader/>} */}
          <Header handleAddMatchModelOpen={handleAddMatchModelOpen} handleChangeLang={handleChangeLang} matchLang={matchLang} handleCreateCardOptionChange={handleCreateCardOptionChange} handleCreateCards={handleCreateCards} createCardOptions={createCardOptions} handleDefault={handleDefault}/>
          <AddMatchModal openAddMatchModal={openAddMatchModal} handleAddMatchModelClose={handleAddMatchModelClose}/>
         {createCardMode ?  
          < MemoCreateCardModeBody
          onFinish={onFinish2}
          form={form} 
          handleLeagueChange={handleLeagueChange} 
          handleMatchChange={handleMatchChange} 
          handleLeagueSearch={handleLeagueSearch} 
          leagues={leagues}
          saveOddsLoading={saveOddsLoading}
          matches={matches}
          handleSave2={handleSave2}
          handleSetMatches={handleSetMatches}
          handleOpenAlert={handleOpenAlert}
          handleSetError={handleSetError}
          createCardOptions={createCardOptions}
          matchLang={matchLang}
          />
          :
          < MemoBody
          onFinish={onFinish}
          form={form} 
          handleLeagueChange={handleLeagueChange} 
          handleMatchChange={handleMatchChange} 
          handleLeagueSearch={handleLeagueSearch} 
          leagues={leagues}
          saveOddsLoading={saveOddsLoading}
          matches={matches}
          handleSave={handleSave}
          handleSetMatches={handleSetMatches}
          handleOpenAlert={handleOpenAlert}
          handleSetError={handleSetError}
          createCardOptions={createCardOptions}
          matchLang={matchLang}
          />
          
          }
        </Spin>

    </div>
  )
}


const Header = ({handleAddMatchModelOpen,handleChangeLang,matchLang,handleCreateCardOptionChange,handleCreateCards,createCardOptions,handleDefault}) => {
  return (
    <div style={{display: 'flex',justifyContent: "end",alignItems: "center"}}>
    <Button style={{marginRight: "2rem",backgroundColor: "rgb(234 234 234)"}} type='dashed' onClick={()=> handleAddMatchModelOpen()}>Add Match</Button>
    <Button style={{marginRight: "2rem",backgroundColor: "rgb(234 234 234)"}} type='dashed' onClick={()=> handleDefault()}>Default</Button>
    <Button style={{marginRight: "2rem",backgroundColor: "rgb(221 221 220)"}} type='dashed' onClick={handleCreateCards}>Create Cards For Fav Leagues</Button>
    <Select
      mode="multiple"
      size="middle"
      placeholder="Please select"
      onChange={handleCreateCardOptionChange}
      style={{width: "20%",marginRight: "1rem"}}
      value={createCardOptions}
      options={[{label: "FT",value: "FT"},{label: "1HT",value: "1HT"},{label: "2HT",value: "2HT"}]}
    />
    <Radio.Group onChange={({target})=>handleChangeLang(target.value)} value={matchLang}>
      <Radio value={'eng'}>Eng</Radio>
      <Radio value={'my'}>Mm</Radio>
    </Radio.Group>
    <Button style={{marginLeft: "2rem",backgroundColor: "rgb(221 221 220)"}} type='dashed' onClick={handleCreateCards}>
        <RefreshOutlinedIcon style={{color: "#673ab7"}}/>
    </Button>
   </div>
  )
}

const AddMatchModal = ({openAddMatchModal: openModel,handleAddMatchModelClose: handleModelClose}) => {
  const [addMatchModalForm] = Form.useForm();
  const [leagues, setLeagues] = useState([]);
  const [homeTeams,setHomeTeams] = useState([]);
  const [awayTeams,setAwayTeams] = useState([]);
  const [searchedHomeTeamName,setSearchedHomeTeamName] = useState("");
  const [searchedAwayTeamName,setSearchedAwayTeamName] = useState("");
  const [seasons,setSeasons] = useState([]);
  const [originalLeagues,setOriginalLeagues] = useState([]);
  const [loading,setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const mounted = useRef(false);

  useEffect(()=> {
    if(mounted.current == false) return;
    getHomeTeams();
  },[searchedHomeTeamName])

  useEffect(()=> {
    if(mounted.current == false) return;
    getAwayTeams();
  },[searchedAwayTeamName])

  useEffect(() => {
    getLeagues();
    getSeasons();
    getHomeTeams();
    getAwayTeams();
    if(mounted.current == false) {
      mounted.current = true;
    }
  },[])

  const handleCloseAlert =()=> setOpenAlert(false);

  async function getLeagues() {
    const startOfDay = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
    const endOfTmr = moment().add(1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');

    // const res = await axios.get(`/info/getLeagueByStatusAndDate?startDate=${startOfDay}&endDate=${endOfTmr}&matchStatus=NS`)
    const res = await axios.get(`/info/getLeague?current=1&pageSize=500&search=`)

    if (res.code != 200 && res.code != 404) {
        setErrorMsg({ code: res.code, msg: res.message });
        setOpenAlert(true)
        return
    }
    const arr = res.data?.leagues?.map(v=> { return ({value: v.id,label: v.league_name_en})})
    setLeagues(arr);
    setOriginalLeagues(arr);
  }

  async function getSeasons() {
    const res = await axios.get(`/info/getSeason?current=1&pageSize=500&search=`);

    if (res.code != 200 && res.code != 404) {
        setErrorMsg({ code: res.code, msg: res.message });
        setOpenAlert(true);
        return;
    }
    const arr = res.data.seasons.map(v=> { return ({value: v.id,label: v.season})})
    setSeasons(arr);
  }

  async function getHomeTeams() {
    let res = await axios.get(`/info/getTeam?current=${1}&pageSize=10&search=${searchedHomeTeamName}`)

    if (res.code != 200 && res.code != 404) {
        setErrorMsg({ code: res.code, msg: res.message });
        setOpenAlert(true);
        return
    }
    const arr = res.data?.teams.map(v=> { return ({value: v.id,label: v.team_name_en})});
    setHomeTeams(arr);
  }

  async function getAwayTeams() {
    let res = await axios.get(`/info/getTeam?current=${1}&pageSize=10&search=${searchedAwayTeamName}`);

    if (res.code != 200 && res.code != 404) {
        setErrorMsg({ code: res.code, msg: res.message });
        setOpenAlert(true);
        return;
    }

    const arr = res.data?.teams.map(v=> { return ({value: v.id,label: v.team_name_en})});
    setAwayTeams(arr);
  }

  function handleLeagueSearch(query){
    const arr = originalLeagues.filter(v => v.label.toLowerCase().includes(query.toLowerCase()));
    setLeagues(arr);
  }

  async function onFinish(values) {
    setLoading(true);
    const params = values
    const res = await axios.post(`/bet/createMatch`, params);
    if(res.code == 200){
      addMatchModalForm.resetFields();
    }
    setErrorMsg({ code: res.code, msg: res.message });
    setOpenAlert(true);
    setLoading(false);    
  }

  function handleHomeTeamSearch(query){
    setSearchedHomeTeamName(query);
 }

 function handleAwayTeamSearch(query){
    setSearchedAwayTeamName(query);
 }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'white',
    borderRadius: "1rem",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModel}
        onClose={handleModelClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openModel} >
          <Box sx={style} css={css`padding: 1.4rem 32px;`}>
            <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert} />
            <div css={css`font-family: cursive;margin-top: 1.4rem;display: flex;justify-content: center;align-items: center;font-size: 1.125rem;`}>
              Add Match
            </div>
            <Form
              name="basic"
              className="modal-points"
              style={{
                marginTop: "2rem",
                fontFamily: "inherit",
              }}
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              autoComplete="off"
              form={addMatchModalForm}
            >

              <Form.Item
                css={css`
                      flex-basis: 50%;
                      .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
                    `}
                label="League"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 17 }}
                name="leagueId"
                style={{ padding: "0 0.4rem", color: "white" }}
                rules={[
                  {
                    required: true,
                    message: `Please select league!`,
                  },
                ]}
              >
                <Select
                  css={css`margin-left: 2rem;`}
                  dropdownStyle={{zIndex: 2000}}
                  size='large'
                  showSearch
                  filterOption={false}
                  onSearch={handleLeagueSearch}
                  options={leagues}
                />
              </Form.Item>

              <Form.Item
                css={css`
                      flex-basis: 50%;
                      .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
                    `}
                label="Home Team"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 17 }}
                name="homeTeamId"
                style={{ padding: "0 0.4rem", color: "white" }}
                rules={[
                  {
                    required: true,
                    message: `Please select home team!`,
                  },
                ]}
              >
                <Select
                  css={css`margin-left: 2rem;`}
                  dropdownStyle={{zIndex: 2000}}
                  size='large'
                  showSearch
                  filterOption={false}
                  onSearch={handleHomeTeamSearch}
                  options={homeTeams}
                />
              </Form.Item>

              <Form.Item
                css={css`
                      flex-basis: 50%;
                      .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
                    `}
                label="Away Team"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 17 }}
                name="awayTeamId"
                style={{ padding: "0 0.4rem", color: "white" }}
                rules={[
                  {
                    required: true,
                    message: `Please select away team!`,
                  },
                ]}
              >
                <Select
                  css={css`margin-left: 2rem;`}
                  dropdownStyle={{zIndex: 2000}}
                  size='large'
                  showSearch
                  filterOption={false}
                  onSearch={handleAwayTeamSearch}
                  options={awayTeams}
                />
              </Form.Item>

              <Form.Item
                css={css`
                      flex-basis: 50%;
                      .ant-form-item-explain-error {margin-left: 2rem !important;font-size: 0.8rem}
                    `}
                label="Season"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 17 }}
                name="seasonId"
                style={{ padding: "0 0.4rem", color: "white" }}
                rules={[
                  {
                    required: true,
                    message: `Please select season!`,
                  },
                ]}
              >
                <Select
                  css={css`margin-left: 2rem;`}
                  dropdownStyle={{zIndex: 2000}}
                  size='large'
                  options={seasons}
                />
              </Form.Item>

              <Form.Item
                css={css`
                      flex-basis: 50%;
                      .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
                    `}
                label="Rounds"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 17 }}
                name="round"
                style={{ padding: "0 0.4rem", color: "white" }}
                onKeyDown={(e)=> ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()} 
                rules={[
                  {
                    required: true,
                    message: `Please input Rounds!`,
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || (value >= 1 && value <= 100)) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Rounds must be between 1 and 100'));
                    },
                  }),
                ]}
              >
                <Input type="number"  size="large" css={css`margin-left: 2rem;`}/>
              </Form.Item>

              <Form.Item
                css={css`
                      flex-basis: 50%;
                      .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
                    `}
                label="Match Date"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 17 }}
                name="matchDate"
                valuePropName='dateString'
                style={{ padding: "0 0.4rem", color: "white" }}
                onKeyDown={(e)=> ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()} 
                rules={[
                  {
                    required: true,
                    message: `Please input match date!`,
                  },
                ]}
              >
                <DatePicker
                  showTime
                  css={css`margin-left: 2rem;`}
                  size='large'
                  popupClassName='custom-antd-calendar-popup'
                  onChange={(value, dateString) => {
                    // console.log('Selected Time: ', value);
                    // console.log('Formatted Selected Time: ', dateString);
                    addMatchModalForm.setFieldValue("matchDate",dateString);
                  }}
                />
              </Form.Item>

              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  padding: "0.6rem 0 0 0",
                  marginTop: "1rem",
                }}
              >
                <ButtonBase
                  component="button"
                  onClick={()=> {
                    addMatchModalForm.resetFields()
                    handleModelClose()
                  }
                  }
                  style={{
                    color: "black",
                    display: "flex",
                    backgroundColor: "#D27685",
                    padding: "0.6rem 1.8rem",
                    borderRadius: "2rem",
                    justifyContent: "center",
                    alignItems: "center",
                    marginRight: "1rem"
                  }}
                >
                  <h4 style={{ textAlign: "center", margin: 0 }}>Cancel</h4>
                </ButtonBase>
                <ButtonBase
                  type="submit"
                  component="button"
                  style={{
                    color: "black",
                    display: "flex",
                    backgroundColor: "#408E91",
                    padding: "0.6rem 1.8rem",
                    borderRadius: "2rem",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {loading? <Loader btn creatUser/> : <h4 style={{ textAlign: "center", margin: 0 }}>Add</h4>}
                </ButtonBase>
              
              </div>
            </Form>
          </Box>
        </Fade>
      </Modal>
  )
}

const Body = ({onFinish,form,handleLeagueChange,handleMatchChange,handleLeagueSearch,leagues,matches,handleSave,saveOddsLoading,handleSetMatches,handleOpenAlert,handleSetError,createCardOptions,matchLang}) =>{
 
  return (
    <div>
      <Form
      form={form}
      name="dynamic_form_nest_item"
      style={{
        marginTop: "2rem",
        fontFamily: "inherit",
      }}
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      autoComplete="off"
      css={css`.ant-form-item-explain-error{font-size: 0.8rem}`}
      >

        <div>
          <Form.List name="data">
              {(fields, { add : leagueAdd, remove : leagueRemove }) =>
              {
                return (
              <>
              {fields.map(({ key : leagueKey, name: leagueIndex, ...restField }) =>
              {
                return  (
                    <div
                    id={`leagueIndex-${leagueIndex}`}
                    className='odd'
                    css={css
                      `
                      ${
                      ` 
                      padding: 30px 30px 6px 30px;
                      margin: 1rem 0;
                      border-radius: 1rem;
                      box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
                      -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
                      -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);`
                       }
                      `}
                    >
                       <div style={{display: "flex",}}>
                          <SelectLeagueCard
                            handleLeagueChange={handleLeagueChange}
                            handleLeagueSearch={handleLeagueSearch}
                            leagues={leagues}
                            form={form}
                            leagueIndex={leagueIndex}
                            matchLang={matchLang}
                          />
                          <MinusCircleOutlined  className="dynamic-delete-button" onClick={() => {
                            leagueRemove(leagueIndex);
                            matches.splice(leagueIndex,1);
                            handleSetMatches(matches)
                          }
                          }
                            style={{marginBottom: "24px",fontSize: "20px",color: 'gray'}}/>
                        </div>
                        <div>
          
                            <Form.List name={[leagueIndex, 'matches']}>
                            {(fields, { add, remove }) => (
                            <>
                            {fields.map(({ key, name, ...restField }) =>
                            {
                                return  (
                                    <SelectMatchCard
                                      key={key}
                                      handleMatchChange={handleMatchChange}
                                      matches={matches}
                                      restField={restField}
                                      name={name}
                                      remove={remove}
                                      form={form}
                                      add={add}
                                      handleSave={handleSave}
                                      leagueIndex={leagueIndex}
                                      matchLang={matchLang}
                                    />
                                )
                            }
                            )}
                             <Form.Item>
                                <Button type="dashed"
                                style={{backgroundColor: "gray",color: 'white'}}
                                onClick={() =>{
                                    if(matches.length == 0 || !matches[leagueIndex]) {
                                        handleSetError({ info: true, msg: "You first need to select league"});
                                        handleOpenAlert()
                                        return
                                    }
                                    add()
          
                                }} block icon={<PlusOutlined />}>
                                Add Match
                                </Button>
                            </Form.Item>
                            </>
                            )}
                            </Form.List>
                        </div>
                    </div>
                  )
              }
              )}
                <Form.Item>
                    <Button type="dashed"
                    style={{backgroundColor: "gainsboro",color: 'black'}}
                    onClick={() =>
                      {
                        leagueAdd();
                        setTimeout(() => {
                          form.getFieldInstance(['data',form.getFieldValue().data.length-1,'leagueId']).focus()
                        }, 100);
                      }}
                    block icon={<PlusOutlined />}>
                    Add League
                    </Button>
                </Form.Item>
            </>
                )}
              }
          </Form.List>
        </div>
        <SaveButton loading={saveOddsLoading} form={form} handleSave={handleSave}/>
      </Form>
    </div>
  )
}

const CreatCardModeBody = ({onFinish2,form,handleLeagueChange,handleMatchChange,handleLeagueSearch,leagues,matches,handleSave2,saveOddsLoading,handleSetMatches,handleOpenAlert,handleSetError,createCardOptions,matchLang}) =>{
 
  return (
    <div>
      <Form
      form={form}
      name="dynamic_form_nest_item"
      style={{
        marginTop: "2rem",
        fontFamily: "inherit",
      }}
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish2}
      autoComplete="off"
      css={css`.ant-form-item-explain-error{font-size: 0.8rem}`}
      >

        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <th style={{ width: "13%",fontFamily: 'Courgette',color: "darkslategray" }}>Time</th>
          <th style={{ width: "7%" ,fontFamily: 'Courgette',color: "darkslategray" }}>HDP</th>
          <th style={{ width: "22%",fontFamily: 'Courgette',color: "darkslategray" }}>Home Team</th>
          <th style={{ width: "22%",fontFamily: 'Courgette',color: "darkslategray" }}>Away Team</th>
          <th style={{ width: "7%" ,fontFamily: 'Courgette',color: "darkslategray" }}>O/U</th>
          {/* <th style={{ width: "7%" ,fontFamily: 'Courgette',color: "darkslategray" }}>Max Limit</th> */}
          <th style={{ width: "7%" ,fontFamily: 'Courgette',color: "darkslategray" }}>Bet Type</th>
          {/* <th style={{ width: "7%" ,fontFamily: 'Courgette',color: "darkslategray" }}>2nd Time</th> */}
        </div>
      
        <div
         className='odd'
           css={css
            `border-radius: 1rem;
             padding-top: 1rem;
             margin-top: 1rem;
            box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);`}
        >              
            <Form.List name='matches'>
            {(fields, { add, remove }) => (
            <>
            {fields.map(({ key, name, ...restField }) =>
            {
                return  (
                    <SelectMatchCard2
                      key={key}
                      handleMatchChange={handleMatchChange}
                      matches={matches}
                      restField={restField}
                      name={name}
                      remove={remove}
                      form={form}
                      add={add}
                      handleSave2={handleSave2}
                      matchLang={matchLang}
                      createCardOptions={createCardOptions}
                    />
                )
            }
            )}
            </>
            )}
            </Form.List>
        </div>
        <SaveButton loading={saveOddsLoading} form={form} handleSave={handleSave2}/>
      </Form>
    </div>
  )
}

const arePropsEqual = (oldProps,newProps) => {
  function compareChildArrayLengths(arrays1, arrays2) {
    if (arrays1.length !== arrays2.length) {
      return false;
    }
    
    for (let i = 0; i < arrays1.length; i++) {
      if (arrays1[i]?.length !== arrays2[i]?.length) {
        return false;
      }
    }
    
    return true;
  }

  const arePropsEqual =   oldProps.leagues.length == newProps.leagues.length &&  oldProps.matchLang == newProps.matchLang && compareChildArrayLengths(oldProps.matches,newProps.matches);
  return arePropsEqual;
}

const arePropsEqual2 = (oldProps,newProps) => {
  function compareChildArrayLengths(arrays1, arrays2) {
    if (arrays1.length !== arrays2.length) {
      return false;
    }
    
    for (let i = 0; i < arrays1.length; i++) {
      if (arrays1[i].length !== arrays2[i].length) {
        return false;
      }
    }
    
    return true;
  }

  const arePropsEqual =   oldProps.leagues.length == newProps.leagues.length &&  oldProps.matchLang == newProps.matchLang && compareChildArrayLengths(oldProps.matches,newProps.matches);
  return arePropsEqual;
}

const MemoBody = memo(Body,arePropsEqual);

const MemoCreateCardModeBody = memo(CreatCardModeBody,arePropsEqual2);

const SelectLeagueCard = ({handleLeagueChange,handleLeagueSearch,leagues,form,leagueIndex,matchLang}) =>{

  return (
    <div style={{width: "100%"}}>
        <Form.Item

          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name={[leagueIndex,'leagueId']}
          style={{ padding: "0 0.4rem", color: "white",width: "100%",display: 'block' }}
        >
        <Select
            // defaultValue={'Ligue 2'}

            style={{width: "30%"  }}
            onChange={(value)=>handleLeagueChange(value,leagueIndex)}
            filterOption={false}
            onSearch={handleLeagueSearch}
            showSearch
            options={leagues.map(league => {
              if(matchLang == 'my'){
                league.label = league.label_mm;
              }else{
                league.label= league.label_en;
              }
              return  league
            })}
            placeholder="Select League"
        />

       </Form.Item>
    </div>
  )
}

const SelectMatchCard2 = ({matches,restField,name,form,handleSave2,matchLang, createCardOptions}) => {
      const fieldNames = ['secondMatchDate','hdp','homeTeam','awayTeam','o/u','betType']

      const handleKeyCode = (keyName,fieldName,fieldIndex) => {

        if(keyName == 'ArrowRight' || keyName == 'Enter'){
          const index = fieldNames.findIndex((name) => name == fieldName);
          let nextFieldName;
          if( keyName == 'Enter' && fieldName == 'hdp'){ // if user clicked 'enter' in 'hdp'
            const obj = form.getFieldValue(['matches', fieldIndex]);
            if(obj.homeTeamHasHandicap != undefined){ // if team is alrealy selected, go to 'odd' input
              nextFieldName = fieldNames[index + 3];
            }else{ // if team is not already selected, go to 'team' input
              nextFieldName = fieldNames[index + 1];
            }
          }else{
            nextFieldName = fieldNames[index + 1];
          }
          if(index == (fieldNames.length - 1)){ // if the field is last in the match
            if(fieldIndex == (form.getFieldsValue().matches.length - 1)){ // if the match is last 
                return;
            }else{ // if the match is not last 
              fieldIndex = fieldIndex + 1
            }
            nextFieldName = fieldNames[0]
          }
         
          if(nextFieldName == 'secondMatchDate'){
            document.getElementById(`secondMatchDate-${fieldIndex}`)?.focus();
          }
          form.getFieldInstance(['matches', fieldIndex, nextFieldName]).focus()
        }

        if(keyName == 'ArrowLeft'){
          const index = fieldNames.findIndex((name) => name == fieldName)
          let nextFieldName = fieldNames[index - 1];
          if(index == 0){  //if the field is first in the match
            if(fieldIndex == 0) { // if the match is first 
              return;
            }else{// if the match is not first 
              fieldIndex = fieldIndex - 1
            }
            nextFieldName = fieldNames[fieldNames.length - 1]
          }
          if(nextFieldName == 'secondMatchDate'){
            document.getElementById(`secondMatchDate-${fieldIndex}`)?.focus();
          }
          form.getFieldInstance(['matches', fieldIndex, nextFieldName]).focus()
        }

        if(keyName == "Control"){
          if(fieldName == 'homeTeam' || fieldName == "awayTeam"){
            const bool = fieldName == 'homeTeam' ? true : false;
            const otherTeamName = bool ? 'awayTeam' : 'homeTeam';
            form.setFieldValue(['matches', fieldIndex, "homeTeamHasHandicap"],bool);
            const teamInstance = form.getFieldInstance(['matches', fieldIndex, fieldName]);
            if(teamInstance){
              teamInstance.input.style.backgroundColor  = 'rgb(44 105 103)';
              teamInstance.input.style.color  = 'white';
              
              const otherTeamInstance = form.getFieldInstance(['matches', fieldIndex, otherTeamName]);
              otherTeamInstance.input.style.backgroundColor  = 'white';
              otherTeamInstance.input.style.color  = 'black';
            }
          }
          if(fieldName == 'popular'){
            const checked = form.getFieldValue(['matches', fieldIndex, fieldName]) ? false : true;
           
            const obj = form.getFieldsValue();
            const matchId = obj.matches[fieldIndex].matchId ;
            obj.matches.forEach((m,matchIndex)=> {
              if(m.matchId == matchId){
                form.setFieldValue(['matches', matchIndex, fieldName],checked);
              }
            })
          }
        }
        if(keyName == 'CapsLock' || keyName == "s"){
          handleSave2(form.getFieldsValue())
        }
        if(keyName == "Delete"){
          const obj = {...form.getFieldsValue()}
          const newArr = obj.matches.filter((v,index)=> index != fieldIndex)
          obj.matches = newArr;
          form.setFieldsValue(obj)
    
          form.getFieldInstance(['matches', fieldIndex-1,fieldNames[fieldNames.length - 1] ])?.focus()

        }
      }

      const matchIndex = name;
      const selectedMatchId = form.getFieldsValue()?.matches[matchIndex]?.matchId;
      const currentCardMatch = matches.find(m=> m.value == selectedMatchId);
      const periods = form.getFieldValue(['matches', name, 'periods']);
      let {matchTime} = {...currentCardMatch};
      let timeFormat ;
      const possibleFormats = [ 'DD-MM-YYYY h:mm A', 'h:mm A'];
      for (const format of possibleFormats) {    
        if (moment(matchTime, format, true).isValid()) timeFormat = format;
      }
      if(periods == 'second_time') matchTime = moment(matchTime, timeFormat).add(1, 'hour').format(timeFormat);

      let periodText ;
      if(periods == 'full_time') periodText = "FT*"
      if(periods == 'first_time') periodText = "1H*"
      if(periods == 'second_time') periodText = "2H*"
      const vsLabel = matchLang == 'my' ? currentCardMatch?.label_mm : currentCardMatch?.label_en;
      const homeTeam = vsLabel?.split(" vs ")[0]
      const awayTeam = vsLabel?.split(" vs ")[1]

      form.setFieldValue(['matches', name, 'homeTeam'],`${periodText} ${homeTeam}`)
      form.setFieldValue(['matches', name, 'awayTeam'],`${periodText} ${awayTeam}`)
      
      form.setFieldValue(['matches', name, 'secondMatchDate'], matchTime)



      const home_team_has_hadicap = form.getFieldValue(['matches', name, 'homeTeamHasHandicap']);

      const validateOddRange = (_, value) => {
        if (value >= 0 && value <= 100) {
          return Promise.resolve();
        }
        return Promise.reject('Odd must be between 0 and 100.');
      };
      const validateMaxLimitRange = (_, value) => {
        if(!value) return Promise.resolve();
        if(/[A-Za-z]/.test(value)){
          const fieldName = _.field.split(".");
          form.setFieldValue(fieldName,value.replace(/[A-Za-z]/g, ''));
          return Promise.resolve();
        }
        if (value >= 0 && value <= 10000000) {
          return Promise.resolve();
        }
        return Promise.reject("0 <=> 10,000,000");
      };

      const validateInputFormat = (_, value) => {
        if(!value) return Promise.resolve();
        const signs = ["+","-","="]
        if(/[A-Za-z]/.test(value)){
          const fieldName = _.field.split(".");
          form.setFieldValue(fieldName,value.replace(/[A-Za-z]/g, ''));
          return Promise.resolve();
        }
        if(signs.includes(value.charAt(0))){
          return Promise.reject( "Invalid Format");
        }  
        const [left, right] = value.split(/[+-]/);   
        // if ((left?.length == 2 && left?.charAt(0) == '0') ||  (Number(left) > 50) || (Number(left) < 0 ) || (right?.charAt(0) === '0') || !right || (Number(right) > 100) ) {
        if ((left?.length == 2 && left?.charAt(0) == '0') ||  (Number(left) > 50) || (Number(left) < 0 )  || !right || (Number(right) > 100) ) {
          return Promise.reject( "Invalid Format");
        }
        return Promise.resolve();
      };

     return (
      <div style={{display: "flex",justifyContent: "space-around"}}>
          {/* <div  style={{width: "13%"}}>{matchTime}</div> */}

          <Form.Item
            wrapperCol={{ span: 24 }}
            {...restField}
            name={[name, 'secondMatchDate']}
            style={{ color: "white", width: "13%" }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {/* Show full date and time as static text */}
              <span style={{ marginRight: 4, color: '#888' }}>
                {
                  (() => {
                    const val = form.getFieldValue(['matches', name, 'secondMatchDate']);
                    return val ? moment(val, 'DD-MM-YYYY hh:mm A').format('DD-MM-YYYY') : '';
                  })()
                }
              </span>
              {/* Editable hour, minute, and second */}
              <span
                id={`secondMatchDate-${name}`}
                contentEditable={true}
                suppressContentEditableWarning={true}
                style={{
                  color: 'black',
                  outline: 'none',
                  textAlign: 'center',
                  cursor: 'text'
                }}
                onKeyDown={e => {
                  if(!createCardOptions.includes("2HT") && e.key !== 'Enter' && e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== "CapsLock"){
                     e.preventDefault();
                     return;
                  }
                  if (
                    e.key !== 'ArrowRight' &&
                    e.key !== 'ArrowLeft' &&
                    (e.key < '0' || e.key > '9') &&
                    e.key !== 'Backspace'
                  ){
                    handleKeyCode(e.key, 'secondMatchDate', name);
                    return;
                  }
                  const allowed =
                    (e.key >= '0' && e.key <= '9') ||
                    e.key === ':' ||
                    e.key === 'Backspace' ||
                    e.key === 'Delete' ||
                    e.key === 'ArrowLeft' ||
                    e.key === 'ArrowRight' ||
                    e.key === 'Tab' ||
                    e.key === 'End' ||
                    e.key === 'Home';
                  if (!allowed) {
                    e.preventDefault();
                    return;
                  }

                  const sel = window.getSelection();
                  const currentText = sel.focusNode?.textContent ?? '';
                  let nextText = currentText;
                  const caret = sel.anchorOffset;

                  // Predict next value
                  let predictedText = currentText;
                  if (e.key.length === 1 && /^[0-9]$/.test(e.key)) {
                    predictedText = currentText.slice(0, caret) + e.key + currentText.slice(caret);
                  }

                  // Auto-insert colon after two digits if no colon yet (for hour and minute)
                  if (
                    e.key.length === 1 && allowed
                  ) {
                    nextText = currentText.slice(0, caret) + e.key + currentText.slice(caret);

                    // Insert first colon after HH
                    if (
                      nextText.length === 2 &&
                      !nextText.includes(':') &&
                      /^[0-9]{2}$/.test(nextText)
                    ) {
                      nextText = nextText + ':';
                      e.preventDefault();
                      sel.focusNode.textContent = nextText;
                      const range = document.createRange();
                      range.setStart(sel.focusNode, 3);
                      range.collapse(true);
                      sel.removeAllRanges();
                      sel.addRange(range);
                      return;
                    }
                    // Insert second colon after HH:mm
                    if (
                      nextText.length === 5 &&
                      nextText.split(':').length === 2 &&
                      /^[0-9]{2}:[0-9]{2}$/.test(nextText)
                    ) {
                      nextText = nextText + ':';
                      e.preventDefault();
                      sel.focusNode.textContent = nextText;
                      const range = document.createRange();
                      range.setStart(sel.focusNode, 6);
                      range.collapse(true);
                      sel.removeAllRanges();
                      sel.addRange(range);
                      return;
                    }
                  } else if (e.key === 'Backspace') {
                    if (caret > 0) {
                      nextText = currentText.slice(0, caret - 1) + currentText.slice(caret);
                    }
                  } else if (e.key === 'Delete') {
                    nextText = currentText.slice(0, caret) + currentText.slice(caret + 1);
                  }

                  // Only allow colons at positions 2 and 5
                  if (e.key === ':' && (caret !== 2 && caret !== 5 || (currentText.match(/:/g) || []).length >= 2)) {
                    e.preventDefault();
                    return;
                  }

                  // Prevent more than 8 characters (HH:mm:ss)
                  if (nextText.length > 8) {
                    e.preventDefault();
                    return;
                  }

                  // Restrict first hour digit to max 2
                  if (
                    nextText.length >= 1 &&
                    nextText[0] &&
                    Number(nextText[0]) > 1 &&
                    (!nextText.includes(':') || caret <= 1)
                  ) {
                    e.preventDefault();
                    return;
                  }

                  // Restrict second hour digit to max 2
                  if (
                    nextText.length >= 2 &&
                    nextText[0] === '1' &&
                    Number(nextText[1]) > 2 &&
                    (!nextText.includes(':') || caret <= 2)
                  ) {
                    e.preventDefault();
                    return;
                  }

                  // Restrict first minute digit to max 5
                  if (
                    nextText.length >= 4 &&
                    nextText[3] &&
                    Number(nextText[3]) > 5
                  ) {
                    e.preventDefault();
                    return;
                  }

                  // Restrict first second digit to max 5
                  if (
                    nextText.length >= 7 &&
                    nextText[6] &&
                    Number(nextText[6]) > 5
                  ) {
                    e.preventDefault();
                    return;
                  }

                  // If nextText is 8 chars, check if it matches HH:mm:ss
                  if (
                    nextText.length === 8 &&
                    !/^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(nextText)
                  ) {
                    e.preventDefault();
                    return;
                  }

                  // Arrow navigation
                  if (e.key === 'ArrowLeft' && caret === 0) {
                    handleKeyCode(e.key, 'secondMatchDate', name);
                    e.preventDefault();
                  }
                  if (
                    e.key === 'ArrowRight' &&
                    caret === currentText.length
                  ) {
                    handleKeyCode(e.key, 'secondMatchDate', name);
                    e.preventDefault();
                  }
                }}
                onBlur={e => {
                  if(!createCardOptions.includes("2HT")) {
                     e.preventDefault();
                     return;
                  }
                  const newTime = e.target.textContent.trim();

                  // Validate HH:mm:ss strictly
                  const timeMatch = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.exec(newTime);
                  if (timeMatch) {
                    const currentValue = form.getFieldValue(['matches', name, 'secondMatchDate']);

                    // Split datetime into date, time, and suffix
                    let [date, oldTime, oldSuffix] = currentValue.split(/[\s]+/);

                    // Extract hours, minutes, seconds from new time
                    let [hours, minutes, seconds] = newTime.split(":").map(Number);

                    // Default to previous suffix (AM/PM)
                    let suffix = oldSuffix;

                    // Convert to 12-hour format
                    let displayHours = hours % 12 || 12;

                    // Build final string
                    const formattedStr = `${date} ${displayHours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")} ${suffix}`;

                    form.setFieldValue(['matches', name, 'secondMatchDate'], formattedStr);

                  } else {
                    e.target.textContent = '';
                  }
                }}
                // Set initial value
                dangerouslySetInnerHTML={{
                  __html: (() => {
                    const val = form.getFieldValue(['matches', name, 'secondMatchDate']);
                    return val ? moment(val, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss') : '';
                  })()
                }}
              />
              {/* Show AM/PM */}
              <span style={{ marginLeft: 4, color: '#888' }}>
                {
                  (() => {
                    const val = form.getFieldValue(['matches', name, 'secondMatchDate']);
                    return val ? moment(val, 'DD-MM-YYYY hh:mm A').format('A') : '';
                  })()
                }
              </span>
            </div>
          </Form.Item>
    
         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'hdp']}
           style={{ color: "white", width: "7%" }}
           rules={[
            { validator: validateInputFormat }
          ]}
         >
           <Input  onKeyDown={(e)=> handleKeyCode(e.key,'hdp',name)}/>
         </Form.Item>

         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'homeTeam']}
           style={{ color: "white", width: "22%",}}
         >
           <Input 
           style={{
            backgroundColor: `${home_team_has_hadicap == true && "rgb(44 105 103)"}`,
            color: `${home_team_has_hadicap == true && "white"}`
          }}
           onKeyDown={(e)=> handleKeyCode(e.key,'homeTeam',name)} type="button" />
         </Form.Item>


         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'awayTeam']}
           style={{ color: "white", width: "22%"}}
         >
           <Input 
             style={{
              backgroundColor: `${home_team_has_hadicap == false && "rgb(44 105 103)"}`,
              color: `${home_team_has_hadicap == false && "white"}`
            }}
             onKeyDown={(e)=> handleKeyCode(e.key,'awayTeam',name)} type="button"/>
         </Form.Item>


         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'o/u']}
           style={{ color: "white", width: "7%" }}
           rules={[
            { validator: validateInputFormat }
          ]}
         >
           <Input onKeyDown={(e)=> handleKeyCode(e.key,'o/u',name)} />
         </Form.Item>
         {/* <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'maxLimit']}
           style={{ color: "white", width: "7%" }}
           rules={[
            { validator: validateMaxLimitRange }
          ]}

         >
           <Input onKeyDown={(e)=> handleKeyCode(e.key,'maxLimit',name)}/>
         </Form.Item> */}

         <Form.Item
           css={css``}
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'betType']}
           style={{ color: "white", width: "7%" }}
         >
           <Select
             style={{ width: "100%", margin: 0 }}
             options={[{ value: "single", label: "single" }, { value: "mix_parlay", label: "Parlay" }, { value: "all", label: "All" }]}
             onKeyDown={(e) => handleKeyCode(e.key, 'betType', name)}
           />
         </Form.Item>
        
      </div>
     )
}

const SelectMatchCard = ({handleMatchChange,matches,restField,name,remove,add,form,handleSave,leagueIndex,matchLang})=>{
    const [count,setCount] = useState(0);
    const handicapGoal = ["=",1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50]
    const handicapSigns = ["+","-"]
    const fieldNames = ['matchId','periods','betType','popular','bodyHandicapTeam','bodyHandicapGoal','bodyOddSign','bodyOdd','ouHandicapGoal','ouOddSign','ouOdd']
    const periodsNames = [{value: "first_time",label: "first half"},{value: "second_time",label: "second half"},{value: "full_time",label: "full time"}];
    

    const handleKeyCode = (keyName,fieldName,fieldIndex) => {

      if(keyName == 'ArrowRight'){
        const index = fieldNames.findIndex((name) => name == fieldName)
        let nextFieldName = fieldNames[index+1]
        if(index == (fieldNames.length - 1)){
          if(fieldIndex == (form.getFieldsValue().data[leagueIndex].matches.length - 1)) return
          fieldIndex = fieldIndex + 1
          nextFieldName = fieldNames[0]
        }
        form.getFieldInstance(['data',leagueIndex,'matches', fieldIndex, nextFieldName]).focus()
      }

      if(keyName == 'ArrowLeft'){
        const index = fieldNames.findIndex((name) => name == fieldName)
        let nextFieldName = fieldNames[index - 1]
        if(index == 0){
          if(fieldIndex == 0) return
          fieldIndex = fieldIndex - 1
          nextFieldName = fieldNames[fieldNames.length - 1]
        }
        form.getFieldInstance(['data',leagueIndex,'matches', fieldIndex, nextFieldName]).focus()
      }

      if(keyName == "Control"){
        handleSave(form.getFieldsValue())
      
      }
      if(keyName == "Delete"){
        const obj = {...form.getFieldsValue()}
        const newArr = obj.data[leagueIndex].matches.filter((v,index)=> index != fieldIndex)
        obj.data[leagueIndex].matches = newArr;
        form.setFieldsValue(obj)
   
        form.getFieldInstance(['data',leagueIndex,'matches', fieldIndex-1,fieldNames[fieldNames.length - 1] ]).focus()

      }
    }

    const matchIndex = name;
    const selectedMatchId = form.getFieldsValue()?.data[leagueIndex]?.matches[matchIndex]?.matchId;
    const currentCardMatch = matches[leagueIndex]?.find(m=> m.value == selectedMatchId);

    const validateOddRange = (_, value) => {
      if (value >= 0 && value <= 100) {
        return Promise.resolve();
      }
      return Promise.reject('Odd must be between 0 and 100.');
    };
    const validateMaxLimitRange = (_, value) => {
      if (value >= 0 && value <= 10000000) {
        return Promise.resolve();
      }
      return Promise.reject('Limit must be between 0 and 10,000,000.');
    };
    return (
        <div css={css
            `padding: 30px 30px 6px 30px;
            margin: 1rem 0;
            border-radius: 1rem;
            box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            `}>
        <div style={{display: "flex",justifyContent: "end",marginBottom: "1rem",marginLeft: "2rem"}}>

          <h4  style={{marginRight: "3rem",fontWeight: "normal"}}>Match Time: {currentCardMatch?.matchTime}</h4>
          <h4 style={{fontWeight: "normal"}}>Status: {currentCardMatch?.matchStatus}</h4>
        </div>
         <div style={{display: "flex",justifyContent:"space-between",alignItems: "center",padding: "0 0.4rem"}}>
             <div style={{display: 'flex',width: '100%',alignItems: 'center'}}>
                 <Form.Item
                    wrapperCol={{ span: 24 }}
                    {...restField}
                    name={[name, 'matchId']}
                    style={{ color: "white",width: "30%" }}
                    
                  >
                    <Select
                        style={{width: "100%" ,margin: 0 }}
                        onChange={()=>{
                          setCount(count+1) //just want to rerender the matchCard component
                        }}
                        filterOption={false}
                        showSearch
                        options={matches[leagueIndex].map(match => {
                          if(matchLang == 'my'){
                            match.label = match.label_mm;
                          }else{
                            match.label= match.label_en;
                          }
                          return  match
                        })}
                        placeholder="Select Match"
                        onSelect={()=> form.getFieldInstance(['data',leagueIndex,'matches', name, 'periods']).focus()}
                        onKeyDown={(e)=> handleKeyCode(e.key,'matchId',name)}
                    />
                 </Form.Item>
                 <Form.Item
                      css={css``}
                      wrapperCol={{ span: 24 }}
                      {...restField}
                      name={[name, 'periods']}
                      style={{ color: "white",width: "20%",marginLeft: "2rem" }}
                      initialValue={'full_time'}
       
                     >
                    <Select
                        style={{width: "100%" ,margin: 0 }}
                        options={periodsNames}
                        placeholder="Select Period"
                        onSelect={()=> form.getFieldInstance(['data',leagueIndex,'matches', name, 'betType']).focus()}
                        onKeyDown={(e)=> handleKeyCode(e.key,'periods',name)}
                    />
                 </Form.Item>
                 <Form.Item
                      css={css``}
                      wrapperCol={{ span: 24 }}
                      {...restField}
                      name={[name, 'betType']}
                      style={{ color: "white",width: "20%",marginLeft: "2rem" }}
                      initialValue={'all'}
                     >
                    <Select
                        style={{width: "100%" ,margin: 0 }}
                        options={[{value: "single",label: "single"},{value: "mix_parlay",label: "Parlay"},{value: "all",label: "All"}]}
                        placeholder="Select Bet Type"
                        onSelect={()=> form.getFieldInstance(['data',leagueIndex,'matches', name, 'popular']).focus()}
                        onKeyDown={(e)=> handleKeyCode(e.key,'betType',name)}
                    />
                 </Form.Item>
                 <Form.Item  name={[name, 'popular']} initialValue={false}
                 css={css``}
                 wrapperCol={{ span: 24 }}
                 {...restField}
                 style={{ color: "white",width: "20%",marginLeft: "2rem" }}
                 >
                <Select
                    options={[{value: true,label: "Popular"},{value: false,label: "Unpopular"}]}
                    onSelect={()=> form.getFieldInstance(['data',leagueIndex,'matches', name, 'bodyHandicapTeam']).focus()}
                    onKeyDown={(e)=> handleKeyCode(e.key,'popular',name)}
                />
                </Form.Item>
                {/* <Form.Item  name={[name, 'maxLimit']} initialValue={0}
                 css={css``}
                 wrapperCol={{ span: 24 }}
                 {...restField}
                 style={{ color: "white",width: "20%",marginLeft: "2rem" }}
                 rules={[
                  { validator: validateMaxLimitRange },
                ]}
                 >
                 <Input size="middle" placeholder="max limit" type='number'
                  onKeyDown={(e)=>{
                    handleKeyCode(e.key,'maxLimit',name);
                    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
                  }
                  }
                  onPressEnter={()=> form.getFieldInstance(['data',leagueIndex,'matches', name, 'bodyHandicapTeam']).focus()}/>
                </Form.Item> */}
                
             </div>
             <MinusCircleOutlined  className="dynamic-delete-button" onClick={() => remove(name)}  style={{marginBottom: "24px",fontSize: "20px",color: 'gray',marginLeft: "1rem"}}/>
         </div>
         <div style={{display: "flex"}}>

             <Form.Item
                  wrapperCol={{ span: 24 }}
                  name={[name,'bodyHandicapTeam']}
                  style={{ padding: "0 0.4rem", color: "white",flexBasis: "25%" }}
                 >
                <Select
                    onChange={handleMatchChange}
                    filterOption={false}
                    // onSearch={handleLeagueSearch}
                    showSearch
                    options={[{value: 'home_team',label: "Home Team"},{value: 'away_team',label: "Away Team"}]}
                    placeholder="Handicap Team"
                    onKeyDown={(e)=> handleKeyCode(e.key,'bodyHandicapTeam',name)}
                    onSelect={()=> form.getFieldInstance(['data',leagueIndex,'matches', name, 'bodyHandicapGoal']).focus()}
                />
             </Form.Item>
             <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name={[name,'bodyHandicapGoal']}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
                 >
                {/* <Input onKeyDown={(e)=> handleKeyCode(e.key,'bodyHandicapGoal',name)} size="middle" placeholder="Handicap Goal" onPressEnter={()=> form.getFieldInstance(['matches', name, 'bodyOdd']).focus()}/> */}
                <Select
                    onChange={handleMatchChange}
                    filterOption={true}
                    // onSearch={handleLeagueSearch}
                    showSearch
                    options={handicapGoal.map(g=>{
                      let value = g;
                      if(g == "=") value = 0;
                      return {value: value,label: g}
                    })}
                    placeholder="Handicap Goal"
                    onKeyDown={(e)=> handleKeyCode(e.key,'bodyHandicapGoal',name)}
                    onSelect={()=> {
                      let bodyOddSign = form.getFieldValue(['data',leagueIndex,'matches', name, 'bodyOddSign']);
                      // if(bodyOddSign == "0+") form.setFieldValue(['data',leagueIndex,'matches', name, 'bodyHandicapGoal'],null) // if user chose = , can't choose handicap goal
                      form.getFieldInstance(['data',leagueIndex,'matches', name, 'bodyOddSign']).focus()
                    }}
                />
             </Form.Item>
             <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name={[name,'bodyOddSign']}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
                  initialValue={'+'}
                 >
                {/* <Input onKeyDown={(e)=> handleKeyCode(e.key,'bodyHandicapGoal',name)} size="middle" placeholder="Handicap Goal" onPressEnter={()=> form.getFieldInstance(['matches', name, 'bodyOdd']).focus()}/> */}
                <Select
at2                    onChange={handleMatchChange}
                    filterOption={true}
                    // onSearch={handleLeagueSearch}
                    showSearch
                    options={handicapSigns.map(g=>{
                      return {value: g,label: g}
                    })}
                    placeholder="odd sign"
                    onKeyDown={(e)=> handleKeyCode(e.key,'bodyOddSign',name)}
                    onSelect={(v)=>{
                      // if(v == "0+") form.setFieldValue(['data',leagueIndex,'matches', name, 'bodyHandicapGoal'],null) // if user chose = , can't choose handicap goal
                      form.getFieldInstance(['data',leagueIndex,'matches', name, 'bodyOdd']).focus()
                    }}
                />
             </Form.Item>
             <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name={[name,'bodyOdd']}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
                  rules={[
                    { validator: validateOddRange },
                  ]}
                 >
                <Input type='number' 
                onKeyDown={(e)=> {
                  handleKeyCode(e.key,'bodyOdd',name);
                  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
                  }
                  } 
                size="middle" placeholder="odd" onPressEnter={()=> form.getFieldInstance(['data',leagueIndex,'matches', name, 'ouHandicapGoal']).focus()}/>
              
             </Form.Item>
         </div>
         <div style={{display: "flex"}}>
             {/* <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
                 >
                <Select options={[{value: "ou",label: "Over/Under"}]} defaultValue={'ou'}/>
             </Form.Item> */}
            
             <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name={[name,'ouHandicapGoal']}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
                 >
                {/* <Input onKeyDown={(e)=> handleKeyCode(e.key,'ouHandicapGoal',name)} size="middle" placeholder="Handicap Goal"  onPressEnter={()=> form.getFieldInstance(['matches', name, 'ouOddSign']).focus()}/> */}
                 <Select
                    onChange={handleMatchChange}
                    filterOption={true}
                    // onSearch={handleLeagueSearch}
                    showSearch
                    options={handicapGoal.map(g=>{ 
                      return {value: g,label: g}
                    }).filter(v => v.value != '=')
                  }
                    placeholder="Handicap Goal"
                    onKeyDown={(e)=> handleKeyCode(e.key,'ouHandicapGoal',name)}
                    onSelect={()=> form.getFieldInstance(['data',leagueIndex,'matches', name, 'ouOddSign']).focus()}
                />
             </Form.Item>
             <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name={[name,'ouOddSign']}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
                  initialValue={'+'}
                 >
                {/* <Input onKeyDown={(e)=> handleKeyCode(e.key,'bodyHandicapGoal',name)} size="middle" placeholder="Handicap Goal" onPressEnter={()=> form.getFieldInstance(['matches', name, 'bodyOdd']).focus()}/> */}
                <Select
                    onChange={handleMatchChange}
                    filterOption={true}
                    // onSearch={handleLeagueSearch}
                    showSearch
                    options={handicapSigns.map(g=>{
                      return {value: g,label: g}
                    })}
                    placeholder="odd sign"
                    onKeyDown={(e)=> handleKeyCode(e.key,'ouOddSign',name)}
                    onSelect={()=> form.getFieldInstance(['data',leagueIndex,'matches', name, 'ouOdd']).focus()}
                />
             </Form.Item>
             <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name={[name,'ouOdd']}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
                  rules={[
                    { validator: validateOddRange },
                  ]}
                 >
                <Input size="middle" placeholder="odd" type='number'
                  onKeyDown={(e)=>{
                    handleKeyCode(e.key,'ouOdd',name);
                    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
                  }
                  }
                  onPressEnter={()=> {
                    if(form.getFieldValue().data[leagueIndex].matches.length == name+1){
                      add()
                      setTimeout(()=>{
                        form.getFieldInstance(['data',leagueIndex,'matches', name+1, 'matchId']).focus()
                      },[100])
                    }
               
                  }}/>
             </Form.Item>
         </div>

     </div>
    )
}

const SaveButton = ({loading,form,handleSave}) =>{
    return(

     <div
         style={{
         display: "flex",
         justifyContent: "end",
         alignItems: "center",
         padding: "0.6rem 0 0 0",
         marginTop: "1rem",
         }}
     >
            
        <ButtonBase
            onClick={()=>handleSave(form.getFieldsValue())}
            component="button"
            style={{
            color: "black",
            display: "flex",
            backgroundColor: "#408E91",
            padding: "0.6rem 1.8rem",
            borderRadius: "2rem",
            justifyContent: "center",
            alignItems: "center",
            }}
        >
            {loading ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 ,color: 'white'}}>Save</h4>}
        </ButtonBase>
     </div>
    )
}


